import { Assignment, ClaimAssigneeRelationshipCanon } from '@eigtech/assignments-types'
import { Contact, GetBookResponse } from '@eigtech/contacts-types'
import { last } from 'lodash-es'
import { useMemo } from 'react'
import { useGetAssignmentsForClaim } from '../api/assignments/getAssignmentsForClaim'

export function useSortClaimContactsByPrimary(
  contactsToSort: Contact[] | undefined,
  book: GetBookResponse | undefined
) {
  const claimNumber = (book?.metadata.type === 'claim' && last(book.bookId.split(':'))) || ''
  const { data: assignments } = useGetAssignmentsForClaim(claimNumber)

  return useMemo(() => {
    const contacts = [...(contactsToSort ?? [])]

    if (assignments?.length) {
      contacts.sort((a, b) => {
        const aContactAssignments = assignments.filter(
          (assignment) => assignment.assignee.assigneeId === a.contactId
        )
        const aWeight = aContactAssignments?.reduce(weightReducer, 0)

        const bContactAssignments = assignments.filter(
          (assignment) => assignment.assignee.assigneeId === b.contactId
        )
        const bWeight = bContactAssignments?.reduce(weightReducer, 0)

        return bWeight - aWeight
      })
    }

    return contacts
  }, [assignments, contactsToSort])
}

function weightReducer(prev: number, cur: Assignment) {
  if (cur.assignable.type !== 'claim') {
    return prev
  }
  const relationship = cur.assignable.assigneeRelationship
  const curWeight = primaryWeights[relationship]
  return curWeight > prev ? curWeight : prev
}

const primaryWeights: Record<ClaimAssigneeRelationshipCanon, number> = {
  primaryContact: 9,
  policyHolder: 8,
  carrier: 7,
  coordinator: 6,
  projectManager: 5,
  reviewer: 4,
  fieldAdjuster: 3,
  inspectionTechnician: 2,
  legalRep: 1,
  deskAdjuster: 1,
  job: 0,
}
